import React from 'react';
import { ResponsiveCalendar } from '@nivo/calendar';

const NivoCalendarChart = ({ data, from, to }) => (
    <ResponsiveCalendar
        data={data}
        from={from}
        to={to}
        emptyColor="#eeeeee"
        colors={['#61cdbb', '#97e3d5', '#e8c1a0', '#f47560']}
        margin={{ top: 30, right: 30, bottom: 30, left: 30 }}  // Adjust margins for more space
        yearSpacing={0}  // More space between years
        monthSpacing={0}  // Add spacing between months
        daySpacing={6}  // Increase day spacing for more clarity
        dayBorderWidth={4}  // Thicker borders for better visibility
        dayBorderColor="#ffffff"
        monthBorderColor={'#fff'}
        legends={[
            {
                anchor: 'bottom-right',
                direction: 'row',
                translateY: 36,
                itemCount: 5,
                itemWidth: 50,
                itemHeight: 50,
                itemsSpacing: 15,
                itemDirection: 'right-to-left',
            },
        ]}
        theme={{
            fontSize: 14,  // Increase font size for better readability
        }}
    />
);

export default NivoCalendarChart;
